import { PkCarousel } from '@uefadigital/panenka-react';
import type { MouseEvent } from 'react';
import { memo } from 'react';

import type { EditorialContent } from '@cobalt/utilities';
import PictureHelper from '@shared/PictureHelper';
import PkCardWithSponsor from '@shared/PkCardWithSponsor';
import GoogleTagManagerHelper from '@tracking/gtm-helper';

import * as styles from './styles.module.scss';

const imgFormats = ['0@s1'];

const MobileCard = ({
  sponsorName,
  photogallery,
  handleClick,
}: {
  sponsorName: string;
  photogallery: EditorialContent;
  handleClick: (index?: number) => (e: MouseEvent) => void;
}) => {
  const trackSlide = (category: 'Swipe' | 'Click', action: 'Previous image' | 'Next image') => (e: CustomEvent) => {
    e.stopPropagation();

    GoogleTagManagerHelper.ga4Event('photo_detail', { section_reference: 'photo_detail', interaction: action });
  };

  return (
    <PkCardWithSponsor sponsorName={sponsorName} className={styles.mobileCard} stroke={false}>
      <PkCarousel
        slidesPerView={1}
        className={styles.carousel}
        pagination={{ clickable: true }}
        navigationPosition='inside'
        slot='heading'
        loop
        autoPlay={{ delay: 3000 }}
        onPkClickPrev={trackSlide('Click', 'Previous image')}
        onPkClickNext={trackSlide('Click', 'Next image')}
        onPkSlidePrev={trackSlide('Swipe', 'Previous image')}
        onPkSlideNext={trackSlide('Swipe', 'Next image')}
        pk-theme='dark'
      >
        {photogallery.photos?.map((photo, i) => (
          <button
            type='button'
            key={`item_${photo.id}`}
            onClick={handleClick(i)}
            aria-label={photo.title}
            className='pk-w--100'
          >
            <PictureHelper formats={imgFormats} image={photo.image} title={photo.title} wrapperClassName='pk-w--100' />
          </button>
        ))}
      </PkCarousel>
      <div slot='body' className='pk-font--base-semibold pk-font-size--m'>
        {photogallery.title}
      </div>
    </PkCardWithSponsor>
  );
};

export default memo(MobileCard);
